import React from 'react';
import {classes, st} from './SkeletonRow.st.css';

export const SkeletonRow = ({children, className}: {children: React.ReactNode; className?: string}) => (
  <div className={st(classes.row, className)}>{children}</div>
);
